import Api from '../api';

export const discountConlicitantes = async () => {
  const response = await Api.get(`/facilitadores/conlicitantes`);

  return response;
};
